import { createContext } from 'react'

// Usage of AnnotationSortOrder, AnnotationStatusFilter will not break the build
// eslint-disable-next-line no-restricted-imports
import {
  AnnotationSortOrder,
  AnnotationStatusFilter,
} from '@sketch/gql-types/expansive'

export interface AnnotationQueryVariablesContextValue {
  shareIdentifier: string
  permanentPageId: string
  versionIdentifier: string
  permanentArtboardId?: string
  annotationStatus: AnnotationStatusFilter
  annotationSort: AnnotationSortOrder
}

export const AnnotationQueryVariablesContext = createContext<AnnotationQueryVariablesContextValue | null>(
  null
)
